<template>
	<div class="mt-15">
		<div class="quiz-filling-text">
			<template v-for="segment in parsedSegments" :key="segment.key">
				<span v-if="segment.type === 'text'" v-html="segment.value"></span>
				<label v-else-if="question.filling_type === 'input'" class="quiz-filling-text-field">
					<input
						v-model="trueAnswers[segment.fieldIndex].secondary_body"
						type="text"
						class="quiz-filling-text-field-input"
						@input="emitAnswers"
						@blur="emitAnswers"
					/>
				</label>
				<label v-else class="quiz-filling-select">
					<select
						v-model="trueAnswers[segment.fieldIndex]"
						class="quiz-filling-select-input"
						@change="emitAnswers"
						@blur="emitAnswers"
					>
						<option v-for="val in groupedAnswersByKey[segment.fieldKey] || []" :key="val.id" :value="val">
							{{ val.secondary_body }}
						</option>
					</select>
				</label>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: "QuizQuestionFilling",

	props: {
		question: Object,
	},

	data() {
		return {
			trueAnswers: [],
		};
	},

	computed: {
		parsedSegments() {
			const text = this.question?.filling_text || "";
			const parts = text.split(/(\{q\d+\})/g).filter((part) => part !== "");
			let fieldIndex = 0;

			return parts.map((part, index) => {
				const match = part.match(/^\{(q\d+)\}$/);

				if (match) {
					const currentFieldIndex = fieldIndex;
					fieldIndex += 1;

					return {
						type: "field",
						key: `field-${currentFieldIndex}`,
						fieldKey: match[1],
						fieldIndex: currentFieldIndex,
					};
				}

				return {
					type: "text",
					key: `text-${index}`,
					value: part,
				};
			});
		},

		placeholderKeys() {
			return this.parsedSegments
				.filter((segment) => segment.type === "field")
				.map((segment) => segment.fieldKey);
		},

		questionInitKey() {
			const answersKey = (this.question?.answers || [])
				.map((answer) => [answer.id, answer.body, answer.correct, answer.secondary_body].join(":"))
				.join("|");

			return [
				this.question?.id,
				this.question?.filling_type,
				this.question?.filling_text,
				answersKey,
			].join("::");
		},

		groupedAnswersByKey() {
			return (this.question?.answers || []).reduce((groups, answer) => {
				const key = answer.body;
				if (!groups[key]) groups[key] = [];
				groups[key].push(answer);
				return groups;
			}, {});
		},
	},

	watch: {
		questionInitKey: {
			immediate: true,
			handler() {
				this.initializeAnswers();
			},
		},
	},

	methods: {
		initializeAnswers() {
			const answers = this.question?.answers || [];

			if (this.question?.filling_type === "input") {
				this.trueAnswers = this.placeholderKeys.map((fieldKey, index) => ({
					...(answers[index] || {}),
					body: fieldKey,
					secondary_body: "",
				}));
			} else {
				this.trueAnswers = this.placeholderKeys.map(() => null);
			}
		},

		emitAnswers() {
			this.$emit("set-answer", this.trueAnswers);
		},
	},
};
</script>
